import { AiFillRightCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const EventDoCard = ({ data }) => {
  return (
    <div className='eventDoCard'>
      <div className=' group bg-white shadow-sm rounded-md border-2 :border-eventDarkYellow hover:border-eventDarkYellow transition-all flex flex-col justify-center items-center  px-3'>
        <h2 className='capitalize text-xl text-eventDarkYellow font-semibold py-4'>
          {data?.title}
        </h2>
        <p className='text-center text-sm text-eventGray'>{data?.desc}</p>
        <div className='commonBtn flex items-center py-4'>
          <Link
            to={data?.url}
            type='button'
            className='text-blue-gray-100 flex items-center justify-center'>
            <AiFillRightCircle
              className='text-eventLightYellow group-hover:text-eventDarkYellow group-hover:translate-x-0.5 group-hover:transition-all group-hover:ease-in'
              size={35}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventDoCard;
